export default "__VITE_ASSET__02egC4T___"